import { Divider, Typography, Input, Row, Col, Popconfirm } from 'antd'
import React from 'react'
import { CustomInput, CustomSelectMenu, CustomTable, HeaderComp } from '../../components';
import Template from '../../Template'
import Member from '../../assets/profile.jpg'
import { DeleteOutlined } from '@ant-design/icons';
import { useState } from 'react';

const SettingUsers = () => {


    const [open, setOpen] = useState(false);



    const tableData = [
        {
            id: '1',
            key: '1',
            assignee: 'Pamela',
            image: { Member },
            role: 'Manager',
            organization: 'Kingsley',
            submission_date: '2022-03-29 10:55:39',
        },
        {
            id: '2',
            key: '2',
            assignee: 'John',
            image: { Member },
            role: 'User',
            organization: 'Kingsley',
            submission_date: '2022-03-29 10:55:39',
        },

    ];


    const options = [
        {
            value: 'manager',
            label: 'Manager',
        },
        {
            value: 'user',
            label: 'User',
        }
    ]
    const columns = [
        {
            title: 'Assignee',
            dataIndex: 'assignee',
            key: 'assignee',
            render: (_, record) => {
                return (

                    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        <img style={{ width: 40, height: 40, borderRadius: '50%' }} src={record.image.Member} alt='user' />
                        <span>{record.assignee}</span>

                    </div>
                );
            },

        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
        },
        {
            title: 'Organization',
            dataIndex: 'organization',
            key: 'organization',
        },
        {
            title: 'Submission Date',
            dataIndex: 'submission_date',
            key: 'submission_date',
        },
        {
            title: 'Action',
            dataIndex: 'delete_user',
            key: 'delete_user',
            align: 'center',
            render: (_, record) => {
                return (
                    <>
                        <Popconfirm title="Are you sure to delete this user?" onConfirm={() => onDelete(record.id)}>

                            <DeleteOutlined style={{ color: 'red', fontSize: 20 }} />
                        </Popconfirm>
                    </>
                );
            },
        },

    ]

    const [dataSource, setDataSource] = useState(tableData)
    const [newUser, setNewUser] = useState({})
    const onChange = (e) => {
        const { value, name } = e.target
        setNewUser(prev => ({ ...prev, [name]: value }))
    }
    const onSearch = (v) => console.log(v.target.value);
    const onDelete = (id) => {
        setDataSource(prev => prev.filter(e => e.id !== id))
    }
    const popupContent = {
        title: 'Add new user',
        body: <PopupContent options={options} onChange={onChange} value={newUser} />
    }

    const onOk = () => {
        console.log(newUser)
    }
    const emptyInput = () => setNewUser({})
    return (
        <Template
            headerTitle={['Settings', 'users']}
        >
            <div className="item_comp" >
                <HeaderComp title="Users" onSearch={onSearch} btnType='popup' popupContnent={popupContent} onOk={onOk} isOpen={open} open={() => setOpen(true)} close={() => { emptyInput(); setOpen(false) }} />
                <CustomTable data={dataSource} columns={columns} />
            </div>
        </Template>
    )
}

export default SettingUsers

export const PopupContent = ({ options, onChange, value }) => {



    return (
        <>
            <div className='add_status flex_ver flex_center' style={{ width: '100%', gap: 10 }}  >
                <CustomInput type='text' value={value.name} name='name' label="User name" onChange={onChange} />
                <CustomSelectMenu onChange={onChange} name='role' placeholder='Role' options={options} />
                <CustomInput type='text' value={value.organization} name='organization' label="Organization" onChange={onChange} />
            </div>
        </>
    )
}